import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import TbstatisticsFilter from './tbstatisticsFilter'
// import { reduxForm, Field } from 'redux-form'
// import { renderTextField, renderCheckbox, renderSelectField } from '../auth/form_helpers'
// import MenuItem from 'material-ui/MenuItem';
// import Paper from 'material-ui/Paper';
import {List, ListItem} from 'material-ui/List';
import ActionFace from 'material-ui/svg-icons/action/face';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton'
import {lightBlack, darkBlack} from 'material-ui/styles/colors';
import Dialog from 'material-ui/Dialog';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import AppBar from 'material-ui/AppBar';
import Waypoint from 'react-waypoint';
import {Card, CardActions, CardHeader, CardText, CardTitle} from 'material-ui/Card';

var params = '?';
var BarChart = require("react-chartjs").Bar;

const styles = {
  m15: {
    margin: 15,
  },
  customContentStyle: {
    width: '100%',
    maxWidth: 'none',
  },
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  plusButton: {
    position: "fixed",
    right: 20,
    bottom: 20,
    zIndex: 1,
  }
};

class Tbstatistics extends Component {

  componentWillUnmount() {
    if (this.props.errorMessage) {
      this.props.authError(null)
    }
  }

  componentWillMount() {
    this.props.getEnums('/dev.enum/affair-stat-categories', '', 'AffairCategories');
    this.props.getEnums('/dev.enum/affair-automated', '?detailed', 'AffairAutomated');
    this.props.fetchMessage('/stats/affair-amounts', '');

  }

  data1 = () => {
    let labels = []
    let data = []
    let first = this.props.message[0].year
    let last = this.props.message[this.props.message.length - 1].year
    for (var i = first; i <= last; i++) {
      let maybeAnObject = this.props.message.filter(function(obj){
        return obj.year === i;
      })
      if (maybeAnObject.length < 1) {
        labels.push(i)
        data.push(0)
      } else if (maybeAnObject.length === 1) {
        labels.push(maybeAnObject[0].year)
        data.push(maybeAnObject[0].count)
      } else {
        maybeAnObject.map((option, index) => {
          labels.push(option.year)
          data.push(option.count)
        })
      }
    }
    return {
      labels: labels,
      datasets: [
        {
          label: "TB ügyek",
          fillColor: "#FFB74D",
          strokeColor: "#FFB74D",
          pointColor: "rgba(220,220,220,1)",
          pointStrokeColor: "#fff",
          pointHighlightFill: "#fff",
          pointHighlightStroke: "rgba(220,220,220,1)",
          data: data
        }
      ]
    };
  }

  chartOptions1 = () => {
    return {
      gridLines: {
        offsetGridLines: true,
      },
      layout: {
        padding: {
          left: 50,
          right: 50,
          top: 0,
          bottom: 0
        }
      },
      responsive: true,
      hover: {
        // Overrides the global setting
        mode: 'index'
      }
    }
  }

  scrollTo = (element, to, duration) => {
      //t = current time
      //b = start value
      //c = change in value
      //d = duration
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      };

      var start = element.scrollTop,
          change = to - start,
          currentTime = 0,
          increment = 20;
          
      var animateScroll = function(){        
          currentTime += increment;
          var val = Math.easeInOutQuad(currentTime, start, change, duration);
          element.scrollTop = val;
          if(currentTime < duration) {
              setTimeout(animateScroll, increment);
          }
      };
      animateScroll();
  }

  handleFilter({category, automated}) {
    params = '?';
    if (typeof category !== 'undefined' && category !== 'all') {
      params = params + '&category='+category
    }
    if (typeof automated !== 'undefined') {
      if (automated !== 'all') {
        params = params + '&automated='+automated
      }
    }
    // console.log(params)
    window.scrollTo(document.body, 0, 1250);
    if (params === '?') {
      this.props.fetchMessage('/stats/affair-amounts', '');
    } else {
      this.props.fetchMessage('/stats/affair-amounts', params);
    }
  }

  render() {
    if(typeof this.props.message !== 'undefined') {
      return (
        <div style={{paddingBottom: 351}}>
          <AppBar
            title="TB ügy statisztikák"
          />
          <TbstatisticsFilter
            affaircategories={this.props.affaircategories}
            affairautomated={this.props.affairautomated}
            onSubmit={this.handleFilter.bind(this)}
            errorMessage={this.props.errorMessage} />
          <div className="cardWrapper">
            <Card className="soloCard" key={0}>
              <CardTitle title="TB ügyek száma" subtitle="" />
              <CardText expandable={false}>
                <span className='toleftbar'>darab</span>
                <BarChart data={this.data1()} options={this.chartOptions1()} redraw />
                <span className='tobottombar'>év</span>
              </CardText>
            </Card>
          </div>
        </div>
      )
    } else {
      return (
        <div>
          <p style={{margin: 16, textAlign: "center"}}><strong>Töltünk...</strong></p>
        </div>

      )

    }
  }
}

function mapStateToProps(state) {
  return {
    message: state.auth.message,
    affaircategories: state.tb.affaircategories,
    affairautomated: state.tb.affairautomated,
    affairstatus: state.tb.affairstatus,
    errorMessage: state.auth.error
  }
}

export default connect(mapStateToProps, actions)(Tbstatistics)


// WEBPACK FOOTER //
// ./src/components/tbstatistics/tbstatistics.js